module.exports = __webpack_public_path__ + "img/258.001a04b7.jpg";